export const dataset = [
  {
    date: new Date("2025-08-06T08:00"),
    total: 150,
    available: 130,
    inUse: 15,
    damaged: 5,
  },
  {
    date: new Date("2025-08-06T12:00"),
    total: 155,
    available: 132,
    inUse: 18,
    damaged: 5,
  },
  {
    date: new Date("2025-08-06T16:00"),
    total: 160,
    available: 135,
    inUse: 20,
    damaged: 5,
  },
  {
    date: new Date("2025-08-07T09:00"),
    total: 160,
    available: 138,
    inUse: 17,
    damaged: 5,
  },
  {
    date: new Date("2025-08-07T13:00"),
    total: 162,
    available: 140,
    inUse: 17,
    damaged: 5,
  },
  {
    date: new Date("2025-08-07T18:00"),
    total: 162,
    available: 137,
    inUse: 20,
    damaged: 5,
  },
  {
    date: new Date("2025-08-08T10:00"),
    total: 165,
    available: 140,
    inUse: 20,
    damaged: 5,
  },
  {
    date: new Date("2025-08-08T15:00"),
    total: 165,
    available: 135,
    inUse: 25,
    damaged: 5,
  },
  {
    date: new Date("2025-08-08T20:00"),
    total: 165,
    available: 130,
    inUse: 30,
    damaged: 5,
  },
];
